import { SternumTheme } from '@sternum/theme';
import { SwitchTheme } from '@sternum/ui';

import { Colors } from '../constants';

export function SBOMDarkSwitchTheme(theme: SternumTheme): SwitchTheme.SwitchTheme {
  return {
    ...SwitchTheme.defaultTheme(theme),
    width: '36px',
    height: '20px',
    thumbSize: '12px',
    activeBackground: Colors.BrandBlueLightest,
    hoverActiveBackground: Colors.BrandBlueLightest,
    activeThumbColor: Colors.BrandBlue,
    inactiveThumbColor: Colors.GreyDarker,
    inactiveBackground: Colors.GreyLightest,
    hoverInactiveBackground: Colors.GreyLightest,
  };
}
